import { useMutation, useQueryClient } from '@tanstack/react-query';
import { newsKeys } from 'store/news';
import { recognitionsKeys } from 'store/recognitions';
import { loaders } from './comments.loaders';

export const useCreateComment = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createComment, {
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries(newsKeys.all),
        queryClient.invalidateQueries(recognitionsKeys.all),
      ]);
    },
  });
};

export const useUpdateComment = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateComment, {
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries(newsKeys.all),
        queryClient.invalidateQueries(recognitionsKeys.all),
      ]);
    },
  });
};

export const useUpdateCommentsStatus = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateCommentsStatus, {
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries(newsKeys.all),
        queryClient.invalidateQueries(recognitionsKeys.all),
      ]);
    },
  });
};

export const useDeleteComments = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.deleteComments, {
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries(newsKeys.all),
        queryClient.invalidateQueries(recognitionsKeys.all),
      ]);
    },
  });
};
